import { updateNamedModelRequest } from 'api/Exec/api';
import { NamedModel } from 'api/Exec/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';
import { FormValues } from 'components/Dashboard/Models/NamedModels/NamedModelForm/NamedModelForm';

import { message, notification } from 'antd';
import { useState } from 'react';

const useEditNamedModel = (onNamedModelUpdated: (namedModel: NamedModel) => void) => {
  const [ isUpdating, setIsUpdating ] = useState<boolean>(false);

  const editNamedModel = (namedModelId: string, values: FormValues) => {
    setIsUpdating(true);

    updateNamedModelRequest(namedModelId, values)
      .then(({ data }) => {
        message.success('Named model was updated');
        onNamedModelUpdated(data);
      })
      .catch((reason) => {
        notification.error({ duration: 0, type: 'error', message: getErrorFromPromiseReason(reason) });
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  return { isUpdating, editNamedModel };
};

export default useEditNamedModel;
